import { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { getEndpointWithParams } from 'queries/queries-utils'
import { statusChecksMutationKeys } from 'queries/status-checks/query-keys'

function deleteStatusCheck(
  mutationKey?: ReturnType<typeof statusChecksMutationKeys.mutateStatusCheck>
) {
  return async () => {
    if (!mutationKey)
      throw new AxiosError(
        'Must supply a status check ID to request a deletion'
      )

    const endpointWithParams = getEndpointWithParams(...mutationKey)
    await agent.delete(endpointWithParams)
  }
}

export function useDeleteStatusCheck(
  statusCheckId?: string,
  options?: Omit<UseMutationOptions<void, Error>, 'mutationKey' | 'mutationFn'>
) {
  const { currentTeamId } = useAuth()
  const mutationKey = statusCheckId
    ? statusChecksMutationKeys.mutateStatusCheck({
        statusCheckId,
        teamId: currentTeamId
      })
    : undefined

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: deleteStatusCheck(mutationKey)
  })
}
